<!-- The notched card silhouette, ported from iOS `SvgTopRightShape`.
     Declared once here in objectBoundingBox units (0..1), which reproduces the iOS behaviour
     exactly: `SvgTopRightShape` scales X and Y independently by rect.width/284 and rect.height/380,
     so the notch stretches with the card rather than staying circular — same as a normalized
     clip-path. Hidden SVG, referenced by `clip-path: url(#evCardNotch)` in the stylesheet. -->
<svg class="ev-card-defs" width="0" height="0" aria-hidden="true" focusable="false">
  <defs>
    <clipPath [attr.id]="notchId" clipPathUnits="objectBoundingBox">
      <path d="M0.81961,0.00000 C0.85656,0.00000 0.88651,0.02239 0.88651,0.05000 L0.88651,0.05759 C0.88651,0.08101 0.91192,0.10000 0.94325,0.10000 C0.97460,0.10000 1.00000,0.11899 1.00000,0.14241 L1.00000,0.93479 C1.00000,0.96967 0.96217,0.99794 0.91549,0.99794 L0.08451,0.99794 C0.03784,0.99794 0.00000,0.96967 0.00000,0.93479 L0.00000,0.06316 C0.00000,0.02828 0.03784,0.00000 0.08451,0.00000 Z" />
    </clipPath>
  </defs>
</svg>

<div class="ev-card" (click)="onOpen()">
  <div class="ev-card-media" [style.clipPath]="notchClipPath">
    <app-event-media class="ev-card-image" [item]="media" [alt]="event.title || ''"></app-event-media>
    <div class="ev-card-scrim"></div>

    <app-event-business-info class="ev-card-biz" *ngIf="showBusinessInfo"
      [event]="event" variant="clear">
    </app-event-business-info>
  </div>

  <div class="ev-card-body">
    <app-event-promotion-badge *ngIf="hasPromotion"></app-event-promotion-badge>

    <div class="ev-card-headline">
      <h3 class="ev-card-title">{{ event.title }}</h3>

      <button type="button" class="ev-card-calendar" (click)="onCalendar($event)"
              [attr.aria-label]="'events.addToCalendar' | translate">
        <app-event-icon name="calendar-add" [size]="20"></app-event-icon>
      </button>
    </div>

    <div class="ev-card-facts">
      <app-event-date-badge [event]="event"></app-event-date-badge>

      <div class="ev-card-where" *ngIf="place || address">
        <div class="ev-card-place" *ngIf="place">{{ place }}</div>
        <div class="ev-card-address" *ngIf="address">{{ address }}</div>
      </div>

      <div class="ev-card-time" *ngIf="time">{{ time }}</div>
    </div>
  </div>
</div>
